import { axiosApi } from 'shared/api/axios'
import { NomenclaturesEndpoint } from './constants'
import { GetNomenclaturesResponseDTO, NomenclatureDTO } from '../model/dtoTypes'
import { adaptNomenclatureDTO } from '../model/adapters/adaptNomenclatureDTO'

export const getNomenclatures = async (page: number = 1) => {
    try {
        const response = await axiosApi.get<GetNomenclaturesResponseDTO>(
            `${NomenclaturesEndpoint.nomenclature}?page=${page}&size=10&order_asc=false&order_by=created_at&storage=true&type_filter=0`,
        )
        return response.data.nomenclatures.map(adaptNomenclatureDTO)
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка загрузки оборудования')
    }
}

export const getNomenclatureById = async (id: number) => {
    try {
        const response = await axiosApi.get<NomenclatureDTO>(
            `${NomenclaturesEndpoint.nomenclature}${id}`,
        )
        return adaptNomenclatureDTO(response.data)
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка загрузки оборудования')
    }
}
